<template>
  <div class="wrapper">
    <div class="header">
      <div class="filters">
        <div class="filter-left">
          <el-radio-group v-model="formParams.stuExamTimeSearch" @input="changeState">
            <el-radio-button :label="1">进行中</el-radio-button>
            <el-radio-button :label="2">已结束</el-radio-button>
          </el-radio-group>
        </div>
        <div class="filter-right">
          <el-radio-group v-model="showtype" style="margin-right: 90px" @input="changeShowType">
            <el-radio-button :label="1">卡片</el-radio-button>
            <el-radio-button :label="2">列表</el-radio-button>
          </el-radio-group>
          <el-input style="width: 200px" v-model="formParams.exam_name" placeholder="请输入练习名称" clearable @keyup.enter.native="getStuPracticeList">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="getStuPracticeList"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="block-list" v-show="showtype === 1">
        <subunitPrictice v-if="examlist.join('') !== ''" :pricticelist="examlist" :stuExamTimeSearch="formParams.stuExamTimeSearch" @methodGoPractice="GoPractice" @methodLookScore="LookScore" />
        <subunitEmpty v-else></subunitEmpty>
      </div>
      <div class="table-list" v-show="showtype === 2">
        <div class="question_wrapper">
          <el-table style="border-radius: 5px;" size="small" :data="examlist" :header-cell-style="{
              background: 'white',
              color: '#606266',
              'font-size': '14px',
            }" stripe>
            <el-table-column align="center" width="50" label="序号">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 + page_size * (page_no - 1) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="练习名称" prop="title">
            </el-table-column>

            <el-table-column align="center" label="开始时间" prop="start_date" width="150">
            </el-table-column>

            <el-table-column align="center" label="结束时间" prop="end_date" width="150">
            </el-table-column>

            <el-table-column align="center" label="已提交次数" width="100">
              <template slot-scope="scope">
                <el-link style="cursor: pointer;" @click="LookScore(scope.row)" type="primary">{{ scope.row.stuExamSubmitTimes }}</el-link>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" fixed="right" width="150">
              <template slot-scope="scope">
                <!-- stuExamSubmitTimes -->

                <el-link v-if="scope.row.post_state == '2'" :disable="true" class="quest_btn" type="info">等待开启</el-link>

                <el-link v-if="
                    formParams.stuExamTimeSearch === 1 &&
                      scope.row.post_state == '1'
                  " class="quest_btn" type="primary" @click="GoPractice(scope.row)">开始练习</el-link>
                <el-link v-if="
                    formParams.stuExamTimeSearch === 2 &&
                      scope.row.post_state == '1'
                  " class="quest_btn" type="primary" @click="LookScore(scope.row)">查看练习</el-link>

                <!--
                <el-link  class="quest_btn" type="primary"
                v-if="scope.row.stuExamSubmitTimes>0"
                  @click="StartPractice1(scope.row)">继续上次练习</el-link>
                  -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="pagination">
      <div class="pagination-box">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" layout="total, prev, pager, next" :page-size="page_size" :total="total"></el-pagination>
      </div>
    </div>

    <el-dialog title="练习提示" :visible.sync="show_practice" width="310px">
      <el-button @click="StartPractice(CurrentData)">开始新的练习</el-button>
      <el-button type="primary" @click="StartPractice1(CurrentData)">继续上次练习</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteExam,
  getStuPracticeList,
  createTestExamStuRecord,
  stuexamGetExamStuSubmitTimes,
} from '@/api/educational'
import { getZoneSchoolSubjectList } from '@/api/community'
import { Seconddiff, time } from '@/config/utils'
// component
import subunitPrictice from '../subunitComponents/subunitPrictice.vue'
import subunitEmpty from '../subunitComponents/subunitEmpty.vue'
export default {
  name: 'practice-list',
  components: {
    subunitPrictice,
    subunitEmpty,
  },
  data() {
    return {
      showtype: 2,
      formParams: {
        subject_id: '',
        exam_name: '',
        owned: true,
        stuExamTimeSearch: 1, // 1进行中 2已结束
      },

      examlist: [],

      form: {
        sort_num: 1,
        title: '',
        subject_id: '',
        desc: '',
        img_url: '',
        imgList: [],
      },
      subjectList: [],
      input: '',
      page_no: 1,
      page_size: 20,
      total: 0,
      show_practice: false,
      CurrentData: {},
    }
  },
  mounted() {
    const practiceListShowType = window.sessionStorage.getItem(
      'practiceListShowType'
    )
    if (practiceListShowType) {
      this.showtype = Number(practiceListShowType)
    }
    const practiceListState = window.sessionStorage.getItem('practiceListState')
    if (practiceListState) {
      this.formParams.stuExamTimeSearch = Number(practiceListState)
    }
    this.getZoneSchoolSubjectList()
    this.getStuPracticeList()
  },

  methods: {
    getZoneSchoolSubjectList() {
      console.log('查询校区科目')

      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },
    changeState() {
      window.sessionStorage.setItem(
        'practiceListState',
        this.formParams.stuExamTimeSearch
      )
      this.page_no = 1
      this.formParams.exam_name = ''
      this.getStuPracticeList()
    },
    changeShowType() {
      window.sessionStorage.setItem('practiceListShowType', this.showtype)
    },
    getStuPracticeList() {
      getStuPracticeList({
        stuExamTimeSearch: this.formParams.stuExamTimeSearch,
        title: this.formParams.exam_name,
        subject_id: this.formParams.subject_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('练习列表')
        console.log(res)
        this.examlist = res.examList
        this.total = res.total
      })
    },

    async GoPractice(row) {
      console.log('开始练习')
      console.log(row)
      const res = await this.methodStuexamGetExamStuSubmitTimes(row.id);
      const { stuExamInfoId, submitTimes } = res;
      console.log('stuExamInfoId:', stuExamInfoId)
      console.log('submitTimes:', submitTimes)
      if (submitTimes > 0) {
        console.log('存在练习记录，用户选择')
        this.show_practice = true
        this.CurrentData = row
      } else {
        console.log('空白练习，开始作答。')
        this.StartPractice(row)
      }
    },
    // 获取学生练习提交次数 examId:练习ID
    async methodStuexamGetExamStuSubmitTimes(examId) {
      return stuexamGetExamStuSubmitTimes({ examId })
    },

    StartPractice1(row) {
      console.log('开始练习')
      console.log(row)

      if (Seconddiff(time(new Date()), row.start_date) < 0) {
        this.$message.warning('练习还未开始,请稍后再试!')
        return
      } else {
        if (Seconddiff(time(new Date()), row.end_date) > 0) {
          this.$message.warning('练习时间已结束!')
          return
        } else {
          this.$router.push({
            name: 'new-practice',
            query: {
              id: row.id,
              title: row.title,
            },
          })
          // createTestExamStuRecord({
          //   examId: row.id

          // }).then((res) => {
          //   console.log(res)

          // })
        }
      }
    },

    StartPractice(row) {
      console.log('开始练习')
      console.log(row)

      if (Seconddiff(time(new Date()), row.start_date) < 0) {
        this.$message.warning('练习还未开始,请稍后再试!')
        return
      } else {
        if (Seconddiff(time(new Date()), row.end_date) > 0) {
          this.$message.warning('练习时间已结束!')
          return
        } else {
          createTestExamStuRecord({
            examId: row.id,
          }).then((res) => {
            console.log(res)
            this.$router.push({
              name: 'new-practice',
              query: {
                id: row.id,
                title: row.title,
              },
            })
          })
        }
      }
    },

    deleteExam(id) {
      this.$confirm('确定删除该考试吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteExam({
          examId: id,
        }).then((res) => {
          console.log('删除考试')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.getStuPracticeList()
          }
        })
      })
    },

    //添加试题
    AddQuestion(row) {
      console.log('添加试题')
      console.log(row)
      this.$router.push({
        name: 'add-question',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    QuestionManagement(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'questionlist',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    Practice(row) {
      console.log('练习')
      console.log(row)
      this.$router.push({
        name: 'practice',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },

    EditExam(row) {
      console.log('编辑考试')
      console.log(row)
      this.$router.push({
        name: 'edit-exam',
        query: {
          title: row.title,
          id: row.id,
        },
        params: {
          examinfo: row,
        },
      })
    },

    addExamStu(row) {
      console.log('考生编辑')
      this.$router.push({
        name: 'edit-examstu',
        query: {
          title: row.title,
          id: row.id,
          subject_id: row.subject_id,
        },
        params: {
          examClassArr: row.examClassArr,
          examCampusArr: row.examCampusArr,
        },
      })
    },

    CreateExam() {
      console.log('创建考试')
      this.$router.push({
        name: 'create-exam',
      })
    },
    LookScore(row) {
      console.log('查看练习记录')
      console.log(row)

      this.$router.push({
        name: 'practice-record1',
        query: {
          title: row.title,
          exam_id: row.id,
          stu_id: this.$store.state.user.userInfo.id,
          realname: this.$store.state.user.userInfo.stuUserInfo.realName,
          state: 'ontime',
        },
        meta: {
          activeMenu: 'practice-list',
        },
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getStuPracticeList()
    },
    handleChangeFile() { },
    handleRemove() { },
    uploadFile() { },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  box-sizing: border-box;
  min-width: 960px;
  min-height: 100%;
  // height: calc(100vh - 60px);
  padding: 20px 20px 70px;
  background-color: #f8f9fb;

  .header {
    .filters {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 89px;
      padding: 0 20px;
      background: #ffffff;
      border-radius: 10px;
      .el-radio-group /deep/ {
        .el-radio-button.is-active {
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background-color: #fff;
            color: #409eff;
          }
        }
      }
      .el-input /deep/ {
        .el-input__inner {
          border-radius: 50px;
        }
      }
    }
    .search {
      width: 250px;
    }

    .search_btn {
      margin-left: 20px;
    }
  }
  .content {
    padding: 20px 0;
    .question_wrapper {
      .quest_btn {
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
  .pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.95);
    border-top: 1px solid #ebedf0;
    z-index: 11;
    .pagination-box {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      max-width: 1680px;
      height: 70px;
      padding: 0 50px;
      margin: auto;
    }
  }
}
</style>
